/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import Seo from "@/components/Seo";
import {
	PageShell,
	SectionDivider,
	SectionWrapper,
} from "./Clientele.page-primitives";
import DotGrid from "../components/customCopmonent/DotGrid";
import MagicBento from "../components/customCopmonent/MagicBento";
import { PageHeaderHero, PAGE_HERO_CLASS } from "../components/customCopmonent/Text/PageHeaderHero";

const pageData = {
	bgimage: "/images/headerPhotos/man.jpeg",
};

const Clientele = () => {
	const { t } = useTranslation();

	return (
		<PageShell>
			<Seo
				titleKey="clientelePage.seo.title"
				descriptionKey="clientelePage.seo.description"
				path="/clientele"
			/>
			<Navigation />{" "}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={t("clientelePage.title")}
					description={t("clientelePage.tagline")}
					meta={t("clientelePage.meta", { returnObjects: true }) as string[]}
				/>
			</SectionWrapper>
			<SectionDivider />
			<SectionWrapper className="relative ">
				<div className="flex py-8 justify-center items-center">
					<MagicBento
						textAutoHide={true}
						enableStars
						enableSpotlight
						enableBorderGlow={true}
						enableTilt={true}
						enableMagnetism={true}
						clickEffect
						spotlightRadius={400}
						particleCount={30}
						glowColor="240, 109, 41"
						// glowColor="67, 0, 139"

						disableAnimations={false}
					/>
				</div>
			</SectionWrapper>
			<SectionDivider />
			<FooterSection />
		</PageShell>
	);
};

export default Clientele;
